export default __webpack_public_path__ + "static/javascript-63a7be100cadd83322fc020c36820172.svg";